import "./assets/scss/index.scss";
import AppRoutes from "./routes";
import { Provider } from "react-redux";
import store from "./store";
import { ToastContainer } from "react-toastify";
import Loader from "./components/Common/Loader";

function App() {
  return (
    <Provider store={store}>
      <AppRoutes />
      <ToastContainer
        position="bottom-center"
        closeOnClick
        hideProgressBar={false}
        autoClose={5000}
        closeButton={false}
      />
      <Loader />
    </Provider>
  );
}

export default App;
